import {PropertyCreateDto, PropertyDto} from "../property/PropertyApi";
import Api from "../../Api";
import {map} from "rxjs/operators";
import Constants from "../../Constants";


export interface RelationshipPropertyApiClient {
    findAllRelationshipProperties(relationshipId: string): Promise<PropertyDto[]>;
    createRelationshipProperty(relationshipId: string, propertyCreate: PropertyCreateDto) : Promise<PropertyDto>;
    updateRelationshipProperty(relationshipId: string, propertyDefinitionId: string, value: string): Promise<void>;
    deleteRelationshipProperty(relationshipId: string, propertyDefinitionId: string): Promise<void>;
}

class RxJsRelationshipPropertyApiClient implements RelationshipPropertyApiClient {

    findAllRelationshipProperties(relationshipId: string) : Promise<PropertyDto[]> {
        return Api.createAjax({
            url: `${Constants.REST_API_URL}/repository/relationships/${relationshipId}/properties`,
            method: "GET",
        }).pipe(map(response => response.response as PropertyDto[]))
            .toPromise();
    }

    createRelationshipProperty(relationshipId: string, propertyCreate: PropertyCreateDto) : Promise<PropertyDto> {
        return Api.createAjax({
            url: `${Constants.REST_API_URL}/repository/relationships/${relationshipId}/properties`,
            method: "POST",
            body: propertyCreate,
        }).pipe(map(response => response.response as PropertyDto))
            .toPromise();
    }

    updateRelationshipProperty(relationshipId: string, propertyDefinitionId: string, value: string): Promise<void> {
        return Api.createAjax({
            url: `${Constants.REST_API_URL}/repository/relationships/${relationshipId}/properties/${propertyDefinitionId}`,
            method: "PUT",
            body: {
                value: value
            }
        }).pipe(map(response => {}))
            .toPromise();
    }

    deleteRelationshipProperty(relationshipId: string, propertyDefinitionId: string): Promise<void> {
        return Api.createAjax({
            url: `${Constants.REST_API_URL}/repository/relationships/${relationshipId}/properties/${propertyDefinitionId}`,
            method: "DELETE",
        }).pipe(map(response => {}))
                .toPromise();
    }

}

export default new RxJsRelationshipPropertyApiClient() as RelationshipPropertyApiClient;